<template>
  <div class="thumbnail-slide">
    <swiper ref="swiper"
            :options="{
              initialSlide: Math.max(0, initialSlide),
              speed: 500,
              watchOverflow: true,
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }">
      <swiper-slide v-for="(device) in deviceList"
                    :key="'thumbnail-' + device">
        <span class="thumbnail"
              :class="`${device}${!thumbnails[device] ? ' no-thumbnail' : ''}`"
              :style="{
                'background-image': 'url(' + (thumbnails[device] || defaultThumbnails[device]) + ')'
              }">
        </span>
      </swiper-slide>
      <span class="swiper-pagination"
            slot="pagination"
            @click.stop></span>
    </swiper>
    <button class="button-prev"
            :disabled="slideIndex === 0"
            @click.stop="slidePrev">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <path fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.073 2.5L5 8 10.073 13.527" />
      </svg>
    </button>
    <button class="button-next"
            :disabled="slideIndex > 1"
            @click.stop="slideNext">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <path fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.073 2.5L5 8 10.073 13.527" />
      </svg>
    </button>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'BaNodeThumbnailSlide',
  components: {
    swiper,
    swiperSlide
  },
  props: {
    thumbnails: {
      type: Object,
      required: true
    },
    defaultThumbnails: {
      type: Object,
      required: true
    },
    initialSlide: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      slideIndex: 0
    }
  },
  computed: {
    deviceList () {
      return this.initialSlide < 0 ? ['desktop', 'phone', 'tablet'] : ['desktop', 'tablet', 'phone']
    }
  },
  created () {
  },
  mounted () {
    this.slideIndex = this.initialSlide
    const swiper = this.$refs.swiper
    if (swiper && swiper.swiper) {
      swiper.swiper.on('slideChange', this.onSlideChange)
    }
  },
  beforeDestroy () {
  },
  methods: {
    slidePrev () {
      this.$refs.swiper.swiper.slidePrev()
    },
    slideNext () {
      this.$refs.swiper.swiper.slideNext()
    },
    onSlideChange () {
      this.slideIndex = this.$refs.swiper.swiper.realIndex
    }
  }
}
</script>

<style lang="scss" scoped>
.thumbnail-slide {
  height: 169px;
  border-radius: 5px 5px 0 0;
  background-color: #777;

  .thumbnail {
    position: relative;
    height: 100%;
    margin: 0 auto;
    background: no-repeat 50% 50% / cover;
    display: block;
    overflow: hidden;

    &.tablet {
      width: 127px;
    }
    &.phone {
      width: 106px;
    }

    &.no-thumbnail {
      &:before {
        width: 100%;
        height: 100%;
        content: '';
        background: inherit;
        display: block;
        transform: scale(1.25);
        filter: blur(5px);
      }
      &:after {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        content: '';
        background: rgba(0, 0, 0, 0.15) url('../../assets/img/journey/icon_add_image.svg') no-repeat 50% 50% / 24px;
      }
    }
  }
}

[class*="button-"] {
  position: absolute;
  left: -14px;
  top: 70px;
  width: 28px;
  height: 28px;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  transition: 0.2s ease-out;
  transition-property: background, box-shadow, opacity;
  pointer-events: auto;
  z-index: 1;

  &.button-next {
    left: auto;
    right: -14px;

    svg {
      transform: scaleX(-1);
    }
  }

  svg {
    position: absolute;
    left: 6px;
    top: 6px;

    path {
      stroke: #444;
      transition: stroke 0.2s ease-out;
    }
  }

  &:disabled {
    opacity: 0;
    pointer-events: none;
  }

  &:hover {
    background-color: #efefef;
  }

  &:active {
    background-image: linear-gradient(to top, #888888 0%, #666666 100%);
    box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(0, 0, 0, 0.06);

    svg {
      path {
        stroke: #fff;
      }
    }
  }
}

.swiper-container {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  overflow: hidden;
  z-index: 1;

  & /deep/ {
    .swiper-wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      box-sizing: content-box;
      display: flex;
      z-index: 1;
      transition-property: transform;
      transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000);
    }
    .swiper-wrapper,
    .swiper-container-android .swiper-slide {
      transform: translate3d(0px, 0, 0);
    }
    .swiper-slide {
      position: relative;
      width: 100%;
      height: 100%;
      flex-shrink: 0;
      background: #777;
      transition-property: transform;
    }
  }

  .swiper-pagination {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 2px;
    width: auto !important;
    height: 16px;
    text-align: center;
    pointer-events: none;
    z-index: 1;
    transform: translate3d(0, 0, 0);

    & /deep/ {
      .swiper-pagination-bullet {
        width: 16px;
        height: 16px;
        vertical-align: top;
        padding: 4px;
        box-sizing: border-box;
        display: inline-block;
        cursor: pointer;
        pointer-events: auto;
      }
      .swiper-pagination-bullet:before {
        width: 8px;
        height: 8px;
        content: '';
        border-radius: 100%;
        background-color: #fff;
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06);
        display: block;
        transition: 0.1s ease-out;
        transition-property: background-color, box-shadow;
      }
      .swiper-pagination-bullet-active:before {
        background-color: #444;
        box-shadow: 0 0 0 1px #fff;
        transition-duration: 0.2s;
      }
    }
  }
}
</style>
